module.exports = __webpack_public_path__ + "img/p63-first-conference-1982.2b7f6ef5.jpg";